<template>
	<div class="box">
		<iframe :src="srcVal" width="100%" height="100%"></iframe>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				srcVal:''
			}
		},
		moutend(){
			this.srcFn()
		},
		methods:{
			srcFn(){
				this.srcVal=this.$rouer.query.srcVal;
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	iframe{
		background: ;
	}
</style>


// WEBPACK FOOTER //
// src/components/iframe.vue